import { render, staticRenderFns } from "./UIPortfolioSearchWithCards.vue?vue&type=template&id=58da5ebe"
import script from "./UIPortfolioSearchWithCards.vue?vue&type=script&lang=js"
export * from "./UIPortfolioSearchWithCards.vue?vue&type=script&lang=js"
import style0 from "./UIPortfolioSearchWithCards.vue?vue&type=style&index=0&id=58da5ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
